module.exports = __webpack_public_path__ + "static/media/Huda_logo.aeb6c7a1.png";